import type { ReactNode } from 'react';

import type { SidebarConfig } from '@/config/sidebarConfig.ts';

import Sidebar from './Sidebar';

interface DashboardLayoutProps {
  sidebarConfig: SidebarConfig;
  children: ReactNode;
}

export default function DashboardLayout({ sidebarConfig, children }: DashboardLayoutProps) {
  return (
    <div className='min-h-screen'>
      <Sidebar config={sidebarConfig} />
      <main className='ml-0 md:ml-70 min-h-screen pt-14 md:pt-0'>{children}</main>
    </div>
  );
}
